import { createAction, props } from '@ngrx/store';

import { Countries } from 'src/models/Countries';
import { Currencies } from 'src/models/Currencies';
import { Salutations } from 'src/models/Salutations';

export const setCountries = createAction(
  '[CoreData] setCountries',
  props<{ countries: Countries }>()
);

export const resetCountries = createAction('[CoreData] resetCountries');

export const setCurrencies = createAction(
  '[CoreData] setCurrencies',
  props<{ currencies: Currencies }>()
);

export const resetCurrencies = createAction('[CoreData] resetCurrencies');

export const setSalutations = createAction(
  '[CoreData] setSalutations',
  props<{ salutations: Salutations }>()
);

export const resetSalutations = createAction('[CoreData] resetSalutations');
